export const iconFontAwesomeMapsBinoculars = (
	<i className="fa-solid fa-binoculars"></i>
);
